import React, { useEffect, useState, useRef } from 'react'; // eslint-disable-next-line
import { Row, Col, Card, CardBody, CardHeader, Button, Image } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api'; // eslint-disable-next-line
import config from '../../config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader';
import avtar from '../../assets/img/team/avatar.svg';
import no_gl_seal_light from '../../assets/img/logos/no_gl_seal_light.png';
import Footer from './Footer';
const ElectionProjectionOpen = props => {
	const { pageLanguageContent, votingData } = props;
	// eslint-disable-next-line
	const [isRunning, setIsRunning] = useState(true);
	const [seconds, setSeconds] = useState(0);
	const intervalRef = useRef(null);
	useEffect(() => {
		let pastTimestamp = Math.floor(votingData?.start_actual);
		const unixTimestampInSeconds = Math.floor(Date.now() / 1000); //unix timestamp
		// Calculate the difference in milliseconds
		let timeDifferenceMs = Math.abs(unixTimestampInSeconds - pastTimestamp); // Use Math.abs for positive difference
		let timerStart = Math.floor(timeDifferenceMs);
		setSeconds(timerStart);
		if (isRunning) {
			// Start the interval
			intervalRef.current = setInterval(() => {
				setSeconds(prevSeconds => prevSeconds + 1);
			}, 1000);
		} else {
			// Clear the interval when not running or component unmounts
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		}

		// Cleanup function to clear the interval when the component unmounts
		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
		// eslint-disable-next-line
	}, [isRunning, votingData]);

	// Function to format the time into HH:MM:SS
	const formatTime = totalSeconds => {
		let hours = Math.floor(totalSeconds / 3600);
		let remainingSeconds = Math.floor(totalSeconds % 3600);
		let minutes = Math.floor(remainingSeconds / 60);
		let seconds = Math.floor(remainingSeconds % 60);
		// Pad with leading zeros if necessary
		const pad = num => num.toString().padStart(2, '0');
		return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
	};
	return (
		<Row className='row g-0 mx-0 fontInter'>
			{/* Left Side - Blue Card */}
			<Col md={6} className='pl-0'>
				<div className='voting-left d-flex flex-column justify-content-between p-4'>
					<div className='content'>
						<span className='badge-election'>
							<i className='fas fa-check-to-slot'></i>{' '}
							{pageLanguageContent['VOT008'] ? pageLanguageContent['VOT008'] : ''}
						</span>
						<h5 className='mt-4 text-white'>
							<Image
								src={votingData.organization_icon ? votingData.organization_icon : no_gl_seal_light}
								alt={votingData?.organization_name}
							/>{' '}
							{votingData?.organization_name}
						</h5>
						<h2 className='text-white'>{votingData?.title}</h2>
						<p className='text-white mt-3'>{votingData?.description}</p>
					</div>
					<Footer pageLanguageContent={pageLanguageContent} votingData={votingData} />
				</div>
			</Col>

			{/* Right Side - Voting Message */}
			<Col md={6} className='rightContest d-flex flex-column justify-content-between'>
				<div className='text-center'>
					{votingData?.contest_number && votingData?.contest_total && (
						<span className='contestBadge'>
							{pageLanguageContent['VOT016']
								? pageLanguageContent['VOT016']
										.replace('_contest_number_', votingData?.contest_number)
										.replace('_contest_total_', votingData?.contest_total)
								: ''}
						</span>
					)}
					<h4>
						<Image
							src={votingData.contest_icon ? votingData.contest_icon : no_gl_seal_light}
							alt={votingData?.contest_name}
						/>
						{votingData?.contest_name}
					</h4>
					{votingData?.candidates &&
						votingData?.candidates.length > 0 &&
						votingData?.candidates.map((item, i) => (
							<div className='votterCard' key={i} id={'tr_' + item?.name}>
								<span className='userIcon'>
									<Image className='img-fluid' src={item.icon ? item.icon : avtar} alt={item?.name} />
								</span>
								<span className='userName'>{item?.name}</span>
							</div>
						))}
				</div>

				<div className='vottingStatus'>
					<span className='Voting-is-open'>{votingData?.status_text}</span>
					<span className='vottingTime'>{votingData?.start_actual && <>{formatTime(seconds)}</>}</span>
				</div>
			</Col>
		</Row>
	);
};
export default ElectionProjectionOpen;
